<template>
    <div class="first-step-container">
        <div class="title">{{ $t('message.passwordRecovery.firstStep.title') }}</div>
        <div class="break-line"></div>
        <div class="step-block">
            <div class="input-block">
                <BaseTextInput
                    :name="'msisdn'"
                    :validate-rules="'msisdn'"
                    :label="$t('message.passwordRecovery.firstStep.login.label')"
                    v-model="login"
                    :mask-pattern="'+375 (##) ###-##-##'"
                />
            </div>
            <div class="btn-block">
                <BaseButton
                    :text="$t('message.passwordRecovery.firstStep.login.btn')"
                    :disabled="isBtnDisabled"
                    @click="nextStep()"
                    :is-loading="isBtnLoading"                    />
            </div>
        </div>
    </div>
</template>

<script>
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
export default {
    name: 'FirstStep',
    inject: ['$httpService'],
    components: {
        BaseTextInput,
        BaseButton
    },
    data() {
        return {
            login: '',
            isBtnLoading: false
        }
    },
    computed: {
        isHasFildsErrors() {
            return this.errors.items.length > 0;
        },
        isHasEmptyFields() {
            return !this.login;
        },
        isBtnDisabled() {
            return this.isHasFildsErrors || this.isHasEmptyFields;
        }
    },
    methods: {
        async nextStep() {
            this.isBtnLoading = true;
            try {
                const parsedLogin = '375'+ this.login;
                // eslint-disable-next-line
                const response = await this.$httpService.msi.sendRecoveryPasswordOtp(parsedLogin);
                
                if (response.data) {
                    this.$toast.success(this.$t('message.signIn.otpToastMsg'));
                    this.$emit('secondStep', parsedLogin);
                }
            } catch (error) {
                console.log(error);   
            }

            this.isBtnLoading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.first-step-container {
    @include base-recovery-password-step-container;
}

.title {
    @include recovery-password-title;
    margin-bottom: 25px;
}

.break-line {
    @include recovery-password-break-line;
}

.step-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.input-block {
    width: 370px;
}

.btn-block {
    width: 150px;
    height: 54px;
}

@media screen and (max-width: 750px) {
    .first-step-container {
        padding: 0 5%;
    }

    .step-block {
        flex-direction: column;
        align-items: flex-start;
    }

    .input-block {
        max-width: 100%;
    }
}
</style>